import { useNavigate, useParams } from 'react-router-dom';
import { useAutomaton } from '../state/AutomatonContext';
import { LineageTree } from '../components/LineageTree';
import { cellIsAlive } from '../lib/survival';

export function Lineage() {
  const { agentId } = useParams();
  const nav = useNavigate();
  const { cells } = useAutomaton();

  // If no id, pick the alive agent with most descendants
  let id = agentId ? parseInt(agentId, 10) : -1;
  if (!agentId || isNaN(id)) {
    let best = -1;
    let bestKids = -1;
    cells.forEach((c) => {
      if (cellIsAlive(c) && c.agent && c.agent.childrenIds.length > bestKids) {
        best = c.id;
        bestKids = c.agent.childrenIds.length;
      }
    });
    id = best;
  }

  const cell = id >= 0 ? cells[id] : null;
  if (!cell) {
    return (
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-12 text-text-mono-dim">
        No lineage to show yet.
      </div>
    );
  }

  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-8 space-y-6">
      <div className="space-y-2">
        <div className="text-blue-life text-xs font-mono uppercase tracking-tightest">/lineage</div>
        <h1 className="font-display font-semibold tracking-tightest text-xl">
          {cell.agent?.name ?? `Cell #${cell.id}`}
        </h1>
        <p className="text-text-secondary text-sm">
          Genealogy traced from the genesis ancestor down to every descendant.
        </p>
        <div className="flex flex-wrap gap-2 text-2xs text-text-mono-dim font-mono">
          <button onClick={() => nav('/grid?cell=' + cell.id)} className="text-blue-life hover:text-blue-glow">
            ← back to grid
          </button>
        </div>
      </div>

      <LineageTree cells={cells} rootId={cell.id} />
    </div>
  );
}
